import { render, staticRenderFns } from "./RadioGroupInput.vue?vue&type=template&id=15b31b0d"
import script from "./RadioGroupInput.vue?vue&type=script&lang=js"
export * from "./RadioGroupInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports